import { render, staticRenderFns } from "./DeviceCardComponent.vue?vue&type=template&id=570f7234&scoped=true"
import script from "./DeviceCardComponent.vue?vue&type=script&lang=js"
export * from "./DeviceCardComponent.vue?vue&type=script&lang=js"
import style0 from "./DeviceCardComponent.vue?vue&type=style&index=0&id=570f7234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570f7234",
  null
  
)

export default component.exports